import * as actionTypes from './constants';


export const jobListRequestInitiated = () => {
    return {
        type: actionTypes.JOB_LIST_REQUEST_INITIATED
    };
};

export const jobListRequestSuccess = (data, searchParams) => {
    return {
        type: actionTypes.JOB_LIST_REQUEST_SUCCESS,
        data,
        searchParams
    };
};

export const jobListRequestFailed = (errorMessage) => {
    return {
        type: actionTypes.JOB_LIST_REQUEST_FAILED,
        payload: errorMessage
    };
};

export const searchJobListRequestInitiated = () => {
    return {
        type: actionTypes.SEARCH_JOB_LIST_REQUEST_INITIATED
    };
};

export const searchJobListRequestSuccess = (data, searchParams) => {
    return {
        type: actionTypes.SEARCH_JOB_LIST_REQUEST_SUCCESS,
        data,
        searchParams
    };
};

export const searchJobListRequestFailed = (errorMessage) => {
    return {
        type: actionTypes.SEARCH_JOB_LIST_REQUEST_FAILED,
        payload: errorMessage
    };
};
